import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import connect from '../../core/EcrionProvider/connect';
import listSelector from '../selectors/list';
import load from '../actions/grid/load';

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    state: listSelector(state, ownProps)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    actions: {
      fetch: function fetch(options) {
        return dispatch(load(_objectSpread({}, ownProps, options)));
      }
    }
  };
};

var DataListValue = connect(mapStateToProps, mapDispatchToProps)(function (_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  return children(_objectSpread({}, rest));
});
export default DataListValue;